export default function _searchInternal() {
    // console.log('geoform');
    // Check if the module exists before doing anything
    const searchInternalComponentExists =
        !!document.querySelector('.search-internal');

    // If the module exists, do whatever we need to
    if (searchInternalComponentExists) {
        // Your code here
        console.log('search internal custom JS');
    }
}
_searchInternal();
